"use client";
import { SetStateAction, useState } from "react";

import {
  Box,
  Typography
} from "@mui/material";

import { brandingColors } from "../../components/utils";
import FooterComponent from "../../components/footer";
import Header from "../../components/header/header";
import DocumentMeta from "react-document-meta";
import "./privacy.css";

export default function Privacy(): JSX.Element {
  const [message, setMessage] = useState("");

  const handleChange = (event: {
    target: { value: SetStateAction<string> };
  }) => {
    setMessage(event.target.value);

    console.log("value is:", event.target.value);
  };
  const [open, setOpenState] = useState(false);

  const meta = {
    title: "Privacy Policy | 123Skincare",
    canonical: "https://www.123skincare.pro/privacy",
  };

  return (
    <DocumentMeta {...meta}>
      <Header showLogo={true} />
      <div className="main privacy-policy-page">
        <div className="container">
          <div className="wrapper">
            <Box
            sx={{
              width: "100%",
              maxWidth: "960px",
              color: brandingColors["green-font"],
              margin: "0 auto",
            }}
            >
            <div><h1>Privacy Statement</h1></div>
            <div className="paragraph">
            <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            This Privacy Statement applies to <a href="https://www.123skincare.pro">www.123skincare.pro</a> , owned and operated by 123Skincare. For the purpose of this Privacy Statement, the terms “123Skincare”, “we”, “us”, or “our”, refers to the whole company group or each of the companies as the case may be.
            </Typography>
            <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            This Privacy Statement represents the full online privacy policy applicable to our activities. The Privacy Statement explains the types of information we collect, how we use, share, and secure the information you provide. It also describes your choices regarding use, access and correction of your personal data.
            </Typography>
            <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            We process personal data within the EU. Our activities are governed in accordance with the General Data Protection Regulation (EU) 2016/679 (the “GDPR”), which is a directly binding legislative act. The GDPR protects fundamental rights and freedoms of natural persons and in particular their right to the protection of personal data.
            </Typography>
            <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            123skincare is considered to be the data controller and will determine the purposes and means of the processing of personal data.
            </Typography>
            </div>

            <div className="paragraph">
            <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
              Updated Privacy Policy
            </Typography>
            <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
              22nd October 2024
            </Typography>
            </div>

            <div className="paragraph">
            <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
            1. Information We Collect
            </Typography>
            <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
            We collect and process personal data necessary for providing and improving our services, which may include:
            <ul>
              <li><strong>Personal Information:</strong> Such as your name, age range, email, when you subscribe email or communicate with us.</li>
              <li><strong>Usage Information:</strong> Data on how you interact with 123Skincare, including search queries, clicks, browsing behavior, and preferences.</li>
              <li><strong>AI Interaction Data:</strong> When you submit queries, we collect those queries to process them through our AI system, which may provide personalized product suggestions.</li>
              <li><strong>Location Information:</strong> Data about your approximate location (e.g., IP address) to deliver relevant results.</li>
              <li><strong>Other Information:</strong> Any other data you voluntarily provide to help us enhance your experience, develop new features, and improve 123Skincare.</li>
            </ul>
            </Typography>
            </div>

            <div className="paragraph">
            <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
              2. Legal Basis for Processing
            </Typography>
            <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
              We process your personal data based on the following legal grounds, in compliance with GDPR:
            <ul>
              <li>
              <strong>Performance of a contract:</strong> To provide you with our services, including personalized AI-based suggestions.
              </li>
              <li>
              <strong>Legitimate interest:</strong> To improve and develop our services, ensure security, and communicate with you about updates.
              </li>
              <li>
              <strong>Consent:</strong> For activities such as processing user queries by AI for personalized product recommendations, and for marketing purposes. You can withdraw your consent at any time by contacting us or updating your preferences in your account settings.
              </li>
            </ul>
          </Typography>
          </div>
          
          <div className="paragraph">
          <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
          3. How We Use Your Information
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
          We use your data to:
          <ul>
            <li>Provide personalized search results and AI-based product suggestions based on your queries.</li>
            <li>Develop new features and communicate with you about updates.</li>
            <li>Protect 123Skincare from fraud and ensure legal compliance.</li>
          </ul>
          </Typography>
          </div>

          <div className="paragraph">
          <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
          4. Automated Decision-Making and Profiling
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
          We use AI systems to analyze your submitted queries and offer personalized product recommendations based on the content of your queries and browsing behavior. This constitutes automated decision-making or profiling. You have the right to:
            <ul>
              <li>
              <strong>Request human intervention</strong> if you disagree with the AI-generated suggestions.
              </li>
            </ul>
          </Typography>
          </div>

          <div className="paragraph">
          <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
          5. Sharing Your Information
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
          We do not sell your personal data. However, we may share your data with:
          <ul>
            <li><strong>Service Providers:</strong> Trusted partners, such as Amazon Web Services (AWS), who assist us in storing and processing data securely.</li>
            <li><strong>AI Providers:</strong> Third-party AI service providers that help us analyze user queries to generate personalized product recommendations.</li>
            <li><strong>Legal Authorities:</strong> When required by law or to protect 123Skincare’s rights or the rights of others.</li>
          </ul>
          </Typography>
          </div>

          <div className="paragraph">
          <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
          6. International Data Transfers
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
          If your data is transferred outside the European Economic Area (EEA), we ensure it is protected through appropriate safeguards, such as:
            <ul>
              <li>Contracts approved by the European Commission.</li>
              <li>Service providers certified under frameworks like the EU-U.S. Data Privacy Framework.</li>
            </ul>
          </Typography>
          </div>

          <div className="paragraph">
          <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
          7. Cookies and Tracking
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
          We use cookies and similar tracking technologies to enhance your experience. You can manage your cookie preferences or block cookies via your browser settings. More details can be found in our Cookie Policy.
          </Typography>
          </div>

          <div className="paragraph">
          <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
          8. Data Retention
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
          We retain your personal data only for as long as necessary to fulfill the purposes for which it was collected, in line with GDPR requirements:
            <ul>
              <li><strong>AI Query Data:</strong> Retained for up to 24 months to improve personalized AI suggestions, after which it is deleted or anonymized.</li>
              <li><strong>Legal Compliance:</strong> Retain certain data for up to 7 years as required by law.</li>
            </ul>
          </Typography>
          </div>

          <div className="paragraph">
          <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
          9. Your Rights Under GDPR
          </Typography>
          <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
          You have the following rights regarding your personal data:
          <ul>
            <li><strong>Access:</strong> Request a copy of the personal data we hold about you.</li>
            <li><strong>Rectification:</strong> Correct inaccurate or incomplete data.</li>
            <li><strong>Erasure:</strong> Request the deletion of your data when no longer needed or if you withdraw consent.</li>
            <li><strong>Restriction:</strong> Request restriction of data processing in certain circumstances.</li>
            <li><strong>Data Portability:</strong> Receive a copy of your data in a structured, machine-readable format.</li>
            <li><strong>Object to Processing:</strong> Object to processing of your data for automated decision-making or profiling.</li>
            <li><strong>Withdraw Consent:</strong> Withdraw consent for data processing at any time.</li>
          </ul>
          To exercise these rights, contact us at <a href="mailto:hello@123skincare.pro">hello@123skincare.pro</a>
          </Typography>
          </div>
          
              <div className="paragraph">
                <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
                  10. Data Security and Retention
                </Typography>
                <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
                  We implement appropriate technical and organizational measures to protect your personal data from unauthorized access, disclosure, or loss. Your data is stored securely using <strong>Amazon Web Services (AWS)</strong>. We retain your data only for as long as necessary to provide services and comply with legal obligations (see Section 8).
                </Typography>
              </div>
          
              <div className="paragraph">
                <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
                  11. Changes to This Policy
                </Typography>
                <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
                  We may update this policy occasionally. Significant changes will be communicated to you via email or other appropriate means. Your continued use of 123Skincare after such updates constitutes acceptance of the changes.
                </Typography>
              </div>

              <div className="paragraph">
                <Typography variant={"h4"} sx={{ marginTop: "20px" }}>
                  12. Contact Us
                </Typography>
                <Typography variant={"body1"} sx={{ marginTop: "20px" }}>
                  For any questions, concerns, or to exercise your rights under GDPR, contact us at: <a href="mailto:hello@123skincare.pro">hello@123skincare.pro</a>
                </Typography>
              </div>
          
            </Box>
            <FooterComponent />
          </div>
        </div>
      </div>
    </DocumentMeta>
  );
}
